/**
 * Root `tabBootstrap` moves its tablist into `.floatingHeader`.
 * Destroy without a replacement tab set leaves that node in the header.
 */
export type FloatingTabNode = {
    parentElement: FloatingTabNode | null;
    remove: () => void;
};

export function removeOwnedFloatingTabs(params: {
    tabsElement: FloatingTabNode | null | undefined;
    floatingHeader: FloatingTabNode | null | undefined;
}): void {
    const tabs = params.tabsElement;
    const header = params.floatingHeader;
    if (!tabs || !header || tabs.parentElement !== header) {
        return;
    }
    tabs.remove();
}
